import { useMutation } from '@tanstack/react-query';
import {
  createFlashbookDesign,
  invalidateFlashbookDesigns,
} from '../../services/flashbooks';
import {
  CreateFlashDesignPayload,
  FlashDesignWithRelations,
} from '../../types/flashbooks';

interface Options {
  onSuccess?: (result: FlashDesignWithRelations) => void | Promise<void>;
  onError?: (error: unknown) => void | Promise<void>;
}

function useCreateFlashbookDesign({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      flashbookId,
      payload,
    }: {
      flashbookId: string;
      payload: CreateFlashDesignPayload;
    }) => createFlashbookDesign({ flashbookId, payload }),
    onSuccess: async result => {
      await invalidateFlashbookDesigns();
      await onSuccess?.(result);
    },
    onError: async error => {
      await onError?.(error);
    },
  });
}

export default useCreateFlashbookDesign;
